var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "curr-month-overview" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "flex-between", staticStyle: { "margin-top": "20px" } },
        [
          _c("div", { staticClass: "flex-align-center" }, [
            _c("span", { staticClass: "title-1" }, [
              _vm._v("\n        " + _vm._s(_vm.twoRemindTitle) + "\n      "),
            ]),
            _c("span", { staticStyle: { color: "#9599a2" } }, [
              _c("span", [
                _vm._v(
                  "\n          已关怀：" +
                    _vm._s(
                      _vm.dataSourceExtra.twoManyRemindStudentCareHaveDealCount
                    ) +
                    "人 (" +
                    _vm._s(_vm.dataSourceExtra.twoManyRemindStudentCareRate) +
                    "%)\n        "
                ),
              ]),
              _c("span", { staticStyle: { margin: "0 10px" } }, [_vm._v("|")]),
              _c("span", [
                _vm._v(
                  "\n          未完整关怀：" +
                    _vm._s(
                      _vm.dataSourceExtra
                        .twoManyRemindStudentCareNotAllDealCount
                    ) +
                    "人 (" +
                    _vm._s(
                      _vm.dataSourceExtra.twoManyRemindStudentCareNotAllDealRate
                    ) +
                    "%)\n        "
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticStyle: { color: "#2a82e4", cursor: "pointer" },
              on: { click: _vm.viewModal },
            },
            [
              _vm._v("\n      查看详情\n      "),
              _c("a-icon", { attrs: { type: "right" } }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "tip", staticStyle: { margin: "12px 0 5px" } }, [
        _c("span", [
          _c("img", {
            staticStyle: {
              width: "14px",
              height: "14px",
              "margin-right": "5px",
            },
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/warningMark.png"),
              alt: "",
            },
          }),
          _vm._v(
            "\n      未完整关怀的" +
              _vm._s(
                _vm.dataSourceExtra.twoManyRemindStudentCareNotAllDealCount
              ) +
              "人中，" +
              _vm._s(
                _vm.dataSourceExtra.twoManyRemindStudentCareDealOnceCount
              ) +
              "人仅关怀1次，" +
              _vm._s(_vm.dataSourceExtra.twoManyRemindStudentCareNotDealCount) +
              "人尚未关怀，建议年级组长3个工作日内督促班主任完成跟进,并将情况反馈至心理中心。\n    "
          ),
        ]),
      ]),
      _c("TableList", {
        staticStyle: { width: "100%" },
        attrs: {
          columns: _vm.twoColumns,
          tableData: _vm.dataSource,
          loading: _vm.loading,
          scroll: {},
        },
      }),
      _c("div", { staticStyle: { "margin-top": "15px" } }, [
        _vm._v(
          "\n    注：完整名单共" +
            _vm._s(_vm.ipagination.total) +
            "人，此处展示部分未完整关怀学生及代表性已关怀学生\n  "
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex-between", staticStyle: { margin: "20px 0 5px" } },
        [
          _c("div", { staticClass: "title-1" }, [
            _vm._v("三次及以上提醒学生（" + _vm._s(_vm.threeTotal) + "人）"),
          ]),
          _c("a-tag", { attrs: { color: "red" } }, [_vm._v("高风险")]),
        ],
        1
      ),
      _c("TableList", {
        staticStyle: { width: "100%" },
        attrs: {
          columns: _vm.threeColumns,
          tableData: _vm.threeDataSource,
          loading: _vm.threeLoading,
          scroll: {},
        },
      }),
      _c("DetailModal", {
        ref: "detailModalRef",
        attrs: {
          title: _vm.twoRemindTitle,
          columns: _vm.twoColumns,
          url: _vm.url,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-align-center" }, [
      _c("div", { staticClass: "record-title" }, [
        _vm._v("多次提醒学生班主任关怀情况"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }